import React, { useEffect, useState } from 'react'
import "./dashboard.scss"
import { MdCardMembership, MdGroup, MdGroups, MdLockReset, MdOutlineCardMembership, MdSend } from 'react-icons/md'
import { getAccountData, getAccountInfo, updateSubscription } from '../../Api';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

function Dashboard() {
    const navigate = useNavigate();
    // const data = [
    //     { label: '6-6', value: 1 }
    // ];
    // const linedata = [
    //     { value: 0 },
    //     { value: 0 },
    //     { value: 5 },
    //     { value: 0 },
    //     { value: 0 }
    // ];

    const [userData, setUserData] = useState(null)
    const [content, setContent] = useState(null);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [selectedSubscriptionType, setSelectedSubscriptionType] = useState(null);

    const [isPopupVisible, setPopupVisible] = useState(false);

    const handleUpgradeClick = () => {
        setPopupVisible(true);
    };

    const handleClosePopup = () => {
        setPopupVisible(false);
    };

    const getPriceId = (planVal, planType) => {
        if(planVal === 'Test' && planType === 'Monthly'){
            return "price_1PrCaqGJGsgTzboDhvFKWJCL"
        }else if(planVal === 'Test' && planType === 'Yearly'){
            return "price_1PrCcYGJGsgTzboDEK70kVoN"
        }else if(planVal === 'Starter' && planType === 'Monthly'){
            return "price_1Q8gnlGJGsgTzboDEkjLxU5f"
        }else if(planVal === 'Starter' && planType === 'Yearly'){
            return "price_1Q8grSGJGsgTzboDOLP7H7qK"
        }else if(planVal === 'Professional' && planType === 'Monthly'){
            return "price_1Q8gswGJGsgTzboDlBxWpGU9"
        }else if(planVal === 'Professional' && planType === 'Yearly'){
            return "price_1Q8guVGJGsgTzboDkLQmayo6"
        }else if(planVal === 'Enterprise' && planType === 'Monthly'){
            return "price_1Q8gswGJGsgTzboDlBxWpGU9"
        }else if(planVal === 'Enterprise' && planType === 'Yearly'){
            return "price_1Q8guVGJGsgTzboDkLQmayo6"
        }else {
            return "";
        }
    }

    const upgradePlan = async () => {
        Swal.fire({
            html: `<img src='/circle-1700_256.gif' style="height: 60px" alt="" />`,
            customClass: { popup: 'loader' },
            showConfirmButton: false,
            heightAuto: false
        })
        if(!selectedPlan){
            Swal.fire({
                text: 'Please select a Plan!',
                icon: 'warning',
                iconColor: '#000',
                showConfirmButton: false,
                heightAuto: false,
                timer: 1500
            });
        }else if(!selectedSubscriptionType){
            Swal.fire({
                text: 'Please select Subscription Type!',
                icon: 'warning',
                iconColor: '#000',
                showConfirmButton: false,
                heightAuto: false,
                timer: 1500
            });
        }else{
            let data = {
                old_price_id: getPriceId(userData.plan, userData.subscription_type),
                new_price_id: getPriceId(selectedPlan, selectedSubscriptionType),
                subscriptionId: userData.subscription_id
            }
            // console.log(data);
            let res = await updateSubscription(data);
            if (res && res.status === 'S') {
                setPopupVisible(false);
                Swal.fire({
                    text: 'Membership updated successfully!',
                    icon: 'success',
                    iconColor: '#000',
                    showConfirmButton: false,
                    heightAuto: false,
                }).then(() => {
                    localStorage.setItem('userData', JSON.stringify({...userData, plan: selectedPlan, subscription_type: selectedSubscriptionType}))
                    let userInfo = JSON.parse(localStorage.getItem('userData') || '{}')
                    setUserData(userInfo);
                });
            }else {
                Swal.fire({
                    text: JSON.stringify(res),
                    icon: 'warning',
                    iconColor: '#000',
                    showConfirmButton: false,
                    heightAuto: false
                });
                // Swal.close()
            }
        }
    }

    useEffect(() => {
        (async () => {
            let userInfo = JSON.parse(localStorage.getItem('userData') || '{}')
            setUserData(userInfo);
            Swal.fire({
                html: `<img src='/circle-1700_256.gif' style="height: 60px" alt="" />`,
                customClass: { popup: 'loader' },
                showConfirmButton: false,
                heightAuto: false
            })
            let res = await getAccountData(userInfo.correl_id);
            if (res.status === 'S') {
                setContent(res.result_info);
                Swal.close()
            } else {
                Swal.close()
            }
            let response = await getAccountInfo(userInfo.correl_id);
            if (response.status === 'S') {
                setUserData(response.result_info);
                localStorage.setItem('userData', JSON.stringify(response.result_info));
                Swal.close()
            } else {
                Swal.close()
            }
        })()
    }, [])

    return (
        <div className='dashboard-page'>
            <div className="dashboardContainer">
                <h5 className='dashboard-heading mb-4'>Hi {userData && userData.first_name}</h5>
                {content && <div className="row g-3">
                    <div className="col-12 col-lg-6">
                        <div className="dashboard-card h-100">
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <img src={require('../../assets/send-email.png')} alt="Invite-Image" className='card-icon' />

                                    <div className="card-body p-0">
                                        <h6 className="card-text">
                                            Total invites sent
                                        </h6>
                                        <p className='mb-0'>{String(content.usedInvites).padStart(2, "0")}</p>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6">
                                    <img src={require('../../assets/omni-channel.png')} alt="Channel-Image" className='card-icon' />
                                    <div className="card-body p-0">
                                        <h6 className="card-text">
                                            Channels used
                                        </h6>
                                        <p className='mb-0'>{String(content.usedChannels).padStart(2, "0")}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="dashboard-card h-100">
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <img src={require('../../assets/received.png')} alt="Invites-Image" className='card-icon' />

                                    <div className="card-body p-0">
                                        <h6 className="card-text">
                                            Available Invites
                                        </h6>
                                        {content.availableInvites !== 'Unlimited' && <p className='mb-0'>{String(content.availableInvites).padStart(2, "0")}</p>}
                                        {content.availableInvites === 'Unlimited' && <p className='mb-0'>Unlimited</p>}
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6">
                                    <img src={require('../../assets/omni-channel.png')} alt="Channels-Image" className='card-icon' />
                                    <div className="card-body p-0">
                                        <h6 className="card-text">
                                            Available Channels
                                        </h6>
                                        {content.availableChannels !== 'Unlimited' && <p className='mb-0'>{String(content.availableChannels).padStart(2, "0")}</p>}
                                        {content.availableChannels === 'Unlimited' && <p className='mb-0'>Unlimited</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="dashboard-card h-100 text-start">
                            <div className="row">
                                <div className="col-12 col-lg-6 mb-4">
                                    <h6 className="card-text">Membership</h6>
                                    <div className="mt-3 card-body p-0">
                                        <button className='btn btn-blue rounded-pill'>{userData && userData.plan}</button>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 mb-4">
                                    <h6 className="card-text">Renewal Date</h6>
                                    <p className='mt-3 mb-0'>{userData && moment(userData.validity_end_date).format("MMMM DD, YYYY")}</p>
                                </div>
                                <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                                    <h6 className='card-text'>Invites Sent</h6>
                                    <p className='mt-3 mb-0'>{String(content.usedInvites).padStart(2, "0")}/{content.totalInvites}</p>
                                </div>
                                <div className="col-12 col-lg-6">
                                    <h6 className='card-text'>Channels Used</h6>
                                    <p className='mt-3 mb-0'>{String(content.usedChannels).padStart(2, "0")}/{content.totalChannels !== 'Unlimited' ? '0'+content.totalChannels : content.totalChannels}</p>
                                </div>
                                <div className="col-12 mt-3 mt-lg-4">
                                    {userData && (userData.plan !== 'Enterprise') && (
                                        <div>
                                            <button className='btn btn-black px-3 py-1 rounded-pill my-2' onClick={() => {navigate('/change-membership')}}>Upgrade Membership</button>
                                        </div>
                                    )}
                                    {userData && (userData.plan === 'Enterprise') && (
                                        <div>
                                            <button className='btn btn-black px-3 py-1 rounded-pill my-2' onClick={handleUpgradeClick}>Renew Plan</button>
                                        </div>
                                    )}
                                    {isPopupVisible && (
                                        <div className="popup-overlay">
                                            <div className="popup-content">
                                                <img src={require('../../assets/cancel-button.png')} onClick={handleClosePopup} className='close-btn' alt='' />
                                                <img
                                                    src={require('../../assets/gr-logo.png')} // Replace with your logo URL
                                                    alt="Star Logo"
                                                    className="popup-logo"
                                                />
                                                {userData && userData.plan === 'Enterprise' && <>
                                                    <p className="popup-text">
                                                        Contact us at{" "}
                                                        <a href="mailto:support@goodreviews.co" className="popup-link">
                                                            support@goodreviews.co
                                                        </a>{" "}
                                                        for support.
                                                    </p>
                                                    <button className="ok-btn" onClick={handleClosePopup}>
                                                        OK
                                                    </button>
                                                </>}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="dashboard-card h-100 text-start justify-content-start">
                            <div>
                                {userData && <h6 className='card-text mb-1'>Full Name</h6>}
                                <div className="card-body p-0 my-1 mb-2">
                                    <p className='mb-0 text-decoration-line'>{userData.first_name} {userData.last_name ? ' ' + userData.last_name : ''}</p>
                                </div>
                                <h6 className='card-text mb-1'>Company Name</h6>
                                <div className="card-body p-0 my-1 mb-2">
                                    <p className='mb-0 text-decoration-line'>{userData && userData.company_name}</p>
                                </div>
                            </div>
                            <div>
                                <h6 className="card-text mb-1">Account Email</h6>
                                <div className="card-body p-0 my-1 mb-2">
                                    <p className='mb-0 text-decoration-line'>{userData && userData.email}</p>
                                </div>
                            </div>
                            <div>
                                <h6 className="card-text mb-1">
                                    Change Password
                                </h6>
                                <div className="card-body p-0">
                                    <button className='btn btn-black px-3 py-1 rounded-pill text-uppercase' onClick={() => { navigate('/reset-password') }}>Change Password</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="row g-3">
                    <div className="col-12 col-lg-6">
                        <div className="dashboard-card h-100">
                            <h6 className="card-text">
                                Total invites sent
                            </h6>
                            <div className="card-body p-0">
                                <MdGroup className='card-icon' />
                                <p className='mt-2 mb-0'>{usedInvites ? usedInvites : 0}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="dashboard-card h-100">
                            <h6 className="card-text">
                                Pending invites
                            </h6>
                            <div className="card-body p-0">
                                <MdSend className='card-tree-icon' />
                                {totalInvites !== 'Unlimited' && <p className='mt-2 mb-0'>{totalInvites - (usedInvites ? usedInvites : 0)}</p>}
                                {totalInvites === 'Unlimited' && <p className='mt-2 mb-0'>Unlimited</p>}
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="dashboard-card h-100">
                            <h6 className="card-text">
                                Membership
                            </h6>
                            <div className="card-body p-0">
                                <MdCardMembership className='card-tree-icon' />
                                <div>
                                    <button className='btn btn-blue rounded-pill my-2'>{userData && userData.plan}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="dashboard-card h-100">
                            <h6 className="card-text">
                                Change Password
                            </h6>
                            <div className="card-body p-0">
                                <MdLockReset className='card-icon' />
                                <div>
                                    <button className='btn btn-black px-3 py-1 rounded-pill mt-2' onClick={() => { navigate('/reset-password') }}>Change Password</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    

                </div> */}
                    {/* <div className="row mt-lg-5">
                    <div className="col-12 col-lg-6">
                        <div className="dashboard-card">
                            <h6 className='card-text text-start px-3'>REVIEWS BY DAY</h6>
                            <Barchart data={data} />
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="dashboard-card">
                            <h6 className='card-text text-start px-3'>AVG. DAILY RATING</h6>
                            <Linechart linedata={linedata} />
                        </div>
                    </div>
                </div> */}
                </div>}

            </div>
        </div >
    )
}

export default Dashboard
